import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/search/page.tsx");
